// Resource-specific terminology. "Umsatz" only makes sense for invoices (actual revenue);
// orders/offers/contracts use "Volumen" instead.

export const RESOURCE_LABELS = {
  orders: {
    volumeLabel: 'Order volume',
    openLabel: 'Open',
  },
  invoices: {
    volumeLabel: 'Revenue',
    openLabel: 'Open',
  },
  offers: {
    volumeLabel: 'Offer volume',
    openLabel: 'Open',
  },
  contracts: {
    volumeLabel: 'Contract volume',
    openLabel: 'Open',
  },
};

export const getResourceLabels = (resource) =>
  RESOURCE_LABELS[resource] ?? RESOURCE_LABELS.orders;
